module.exports = __webpack_public_path__ + "img/achievement_17.4b744999.png";